export const defaultMenuType = 'menu-default' // 'menu-default', 'menu-sub-hidden', 'menu-hidden';
export const subHiddenBreakpoint = 1440
export const menuHiddenBreakpoint = 768

export const defaultLocale = 'ko'
export const defaultDirection = 'ltr'
export const localeOptions = [
  { id: 'ko', name: '한국어', direction: 'ltr' },
  { id: 'en', name: 'English', direction: 'ltr' }
]


export const currentUser = {
  username : null ,
  userGrade : null ,
}

// export const

export const isDemo = true
export const themeRadiusStorageKey = 'theme_radius'
export const defaultColor = 'light.red'
export const colors = [
  'light.purple',
  'dark.purple',
  'light.blue',
  'dark.blue',
  'light.green',
  'dark.green',
  'light.orange',
  'dark.orange',
  'light.red',
  'dark.red'
]


// favicon.ico
